import clsx from 'clsx'
import type { SvgIconProps } from 'LuxKit/SvgIcon'
import { SVG_ICON_SIZE_CSS_VAR, SVG_ICON_SIZES } from 'LuxKit/SvgIcon'
import { rem } from 'polished'
import styled from 'styled-components'
import LineLuxuryEscapesMonogramIcon from '../line/LineLuxuryEscapesMonogramIcon'
import { getThemeClassName } from 'lib/theme/themeUtils'

const Logo = styled(LineLuxuryEscapesMonogramIcon)`
  transform: scale(0.66);
`

const Icon = styled.div`
  flex-shrink: 0;
  display: grid;
  place-items: center;
  height: var(${SVG_ICON_SIZE_CSS_VAR}, ${SVG_ICON_SIZES.M});
  width: var(${SVG_ICON_SIZE_CSS_VAR}, ${SVG_ICON_SIZES.M});
  border-radius: ${props => props.theme.borderRadius.round};
  box-shadow: inset 0 0 0 1px var(--stroke, transparent);

  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
    --stroke: ${props => props.theme.palette.product.loyalty.bronze.normalForeground};
  }
  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
    --stroke: ${props => props.theme.palette.product.loyalty.silver.normalForeground};
  }
  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
    --stroke: ${props => props.theme.palette.product.loyalty.gold.normalForeground};
  }
  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
    --stroke: ${props => props.theme.palette.product.loyalty.platinum.normalForeground};
  }
  &.tier-infinite {
    background: ${props => props.theme.palette.product.loyalty.infinite.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.infinite.normalContrast};
    --stroke: ${props => props.theme.palette.product.loyalty.infinite.normalForeground};
  }
`

interface Props extends Pick<SvgIconProps, 'size' | 'className'> {
  tier: App.LoyaltyTier
}

function LoyaltyTierIcon({ tier, size, className }: Props) {
  const mappedSize = typeof size === 'string' ? SVG_ICON_SIZES[size] : typeof size === 'number' ? rem(size) : undefined

  return <Icon
    className={clsx(className, `tier-${tier}`, getThemeClassName({ mobile: 'default' }))}
    style={{
      [SVG_ICON_SIZE_CSS_VAR]: mappedSize,
    }}
  >
    <Logo size={size} />
  </Icon>
}

export default LoyaltyTierIcon
